export default "__VITE_ASSET__CEjHzMcR__"